<div class="popper">
    <div v-show="showPopper" ref="content" class="popper__content" :class="arrowClass">
        <slot></slot>
        <div v-if="arrow" ref="arrow" class="popper__arrow"></div>
    </div>
    <slot name="anchor"></slot>
</div>
